import { enqueueSnackbar } from "notistack";
import { URLdecode } from "../utils/url";

export default function useCommonActions() {
  const handleInitializePayment = async ({
    savedCard,
    method,
    setModalOpen,
    setLoading,
    initializePayment,
  }) => {
    const parameters = URLdecode();
    if (!parameters?.id)
      return enqueueSnackbar("Your booking id is missing!", {
        variant: "warning",
      });
    switch (method) {
      case "Card":
        await initializePayment({
          setLoading,
          paymentType: method,
          id: parameters?.id,
        });
        break;
      case "Wallet":
        setModalOpen(true);
        break;
      case "SavedCard":
        if (savedCard) {
          await initializePayment({
            setLoading,
            paymentType: method,
            savedCard,
            id: parameters?.id,
          });
        } else {
          enqueueSnackbar("Please select card", { variant: "warning" });
        }
        break;
      default:
        console.error("Invalid payment method");
        return;
    }
  };

  return {
    handleInitializePayment,
  };
}
